import { render, staticRenderFns } from "./PositionPickerOption.vue?vue&type=template&id=1a6be1e6&scoped=true"
import script from "./PositionPickerOption.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionPickerOption.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PositionPickerOption.vue?vue&type=style&index=0&id=1a6be1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6be1e6",
  null
  
)

export default component.exports